export const pickDataProps = (props = {}) => {
    return Object.keys(props).reduce((buf, key) => {
        if (key.includes('data-')) {
            buf[key] = props[key];
        }
        return buf;
    }, {});
};
